@if (confirmationPage) {
  <app-confirmation-page />
} @else {
  <div id="payment" class="bg-gray-100 h-full overflow-y-auto">
    <!-- Back Button -->
    <div class="hidden md:block m-5 mb-3">
      <button
        class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-white"
        (click)="goCheckout()">
        <span class="mr-4"
          ><img src="/assets/img/arrow-left-black-icon.svg" alt=""
        /></span>
        Back
      </button>
    </div>

    <div class="md:mx-auto px-5 lg:px-10 xl:px-20 py-7 md:py-14 md:pt-0 w-full">
      <div class="mb-7 md:mb-3 md:text-left text-center">
        <h1 class="mb-1 text-4xl">Payment</h1>
        <div
          class="flex sm:flex-row flex-col justify-between items-center mt-3">
          <app-timer
            (transactionExpired)="onTransactionExpired()"
            [createdTime]="
              this.transaction()!.transaction.createdAt
            "></app-timer>
          <app-okta-container
            (patronEmmiter)="oktaEventEmitter($event)"></app-okta-container>
        </div>
      </div>

      @if (patron) {
        <app-patron
          (blurInputCredits)="onBlurInputCredits()"
          (changeDigitalWalletSelector)="onChangeDigitalWalletSelector()"
          (checkboxPayInFullChange)="checkboxPayInFullChange($event)"
          [patron]="patron"
          [paymentDetails]="paymentDetails"
          [showCreditsApplies]="showCreditsApplies"
          [substractCreditsToBalance]="substractCreditsToBalance"
          [transaction]="transaction()!" />
      }

      <!-- Payment Options -->
      <div class="px-4 xs:px-6 py-2 md:py-4 w-full md:min-h-[704px] box-white">
        <form #paymentForm="ngForm">
          <div class="flex flex-wrap md:h-full">
            <div
              class="md:flex md:flex-col my-2 md:my-0 md:p-5 md:w-1/2 md:h-auto">
              <app-checkout-recap
                [transaction]="transaction()!"
                [paymentDetails]="paymentDetails"
                [isTicketFeeEnabled]="isTicketFeeEnabled()" />
            </div>

            <!-- Guest/Customer data -->
            <div id="braintree" class="mb-2 md:mb-0 md:p-5 w-full md:w-1/2">
              <div class="mb-2 sm:mb-0">
                <div class="sm:flex sm:mb-4">
                  <div class="w-full">
                    <label class="label" for="first-name">First name</label>
                    <input
                      type="text"
                      class="input"
                      placeholder="First name"
                      id="first-name"
                      name="first-name"
                      [(ngModel)]="paymentDetails.firstName"
                      [readOnly]="patron" />
                  </div>
                  <div class="sm:ml-6 w-full">
                    <label class="label" for="last-name">Last name</label>
                    <input
                      type="text"
                      class="input"
                      placeholder="Last name"
                      id="last-name"
                      name="last-name"
                      [(ngModel)]="paymentDetails.lastName"
                      [readOnly]="patron" />
                  </div>
                </div>
                @if (
                  configuration.custom.paymentPage.captureAddress &&
                  paymentDetails.address
                ) {
                  <!-- Address and Postal Code-->
                  <div class="sm:flex sm:mb-4">
                    <div class="w-full">
                      <label class="label" for="first-name">Address</label>
                      <input
                        type="text"
                        class="input"
                        placeholder="Line 1"
                        id="address"
                        name="address"
                        [(ngModel)]="paymentDetails.address.address1"
                        [readOnly]="patron" />
                    </div>
                    <div class="my-3 sm:my-0 sm:ml-6 w-full">
                      <label class="label" for="last-name">Postal Code</label>
                      <input
                        type="text"
                        class="input"
                        placeholder="Postal Code"
                        id="postalCode"
                        name="postalCode"
                        [(ngModel)]="paymentDetails.address.postalCode"
                        [readOnly]="patron" />
                    </div>
                  </div>
                  <!-- CITY, SUB AND COUNTRY-->
                  <div class="xs:flex xs:flex-wrap">
                    <div
                      class="mb-4 w-full xs:w-1/2 sm:w-1/3 md:w-1/2 lg:w-1/3">
                      <label class="label" for="Country">Country</label>
                      <select
                        type="text"
                        [disabled]="!!patron"
                        class="bg-white input"
                        (ngModelChange)="onChangeCountry($event)"
                        id="countryCode"
                        name="countryCode"
                        [(ngModel)]="paymentDetails.address.countryCode">
                        @for (item of countryList; track item.icaoCode) {
                          <option [value]="item.icaoCode">
                            {{ item.name }}
                          </option>
                        }
                      </select>
                    </div>
                    <div
                      class="mb-4 w-full xs:w-1/2 sm:w-1/3 md:w-1/2 lg:w-1/3">
                      <div class="xs:pl-6">
                        <label class="text-nowrap label" for="last-name"
                          >Sub Country Code</label
                        >
                        <select
                          type="text"
                          class="bg-white input"
                          [disabled]="!!patron"
                          id="SubCountryCode"
                          name="SubCountryCode"
                          [(ngModel)]="paymentDetails.address.subCountryCode">
                          @for (
                            item of subCountryList;
                            track item.sub_country_code
                          ) {
                            <option [value]="item.sub_country_code">
                              {{ item.sub_country_name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                    <!-- mb-4 lg:mb-0 lg:ml-6 -->
                    <div class="mb-4 w-full sm:w-1/3 md:w-full lg:w-1/3">
                      <div class="sm:pl-6 md:pl-0 lg:pl-6">
                        <label class="sm:pl-6 label" for="city">City</label>
                        <input
                          type="text"
                          class="input"
                          placeholder="Boston"
                          id="city"
                          name="city"
                          [(ngModel)]="paymentDetails.address.city"
                          [readOnly]="patron" />
                      </div>
                    </div>
                  </div>
                }
                <div class="mb-3 md:mb-4">
                  <div class="w-full">
                    <label class="label" for="email">Email</label>
                    <input
                      type="email"
                      class="input"
                      placeholder="example@gmail.com"
                      id="email"
                      name="email"
                      [(ngModel)]="paymentDetails.email"
                      email
                      [readOnly]="patron" />
                  </div>
                  <p class="mt-1">
                    *Tickets will be delivered to this email in the MLB Ballpark
                    App.
                    <button
                      class="inline-flex bg-main disabled:opacity-30 rounded-full w-4 h-4 text-white disabled:hover:transform-none hover:scale-95 transition-transform btn-icon"
                      (click)="infoEmailModal()">
                      i
                    </button>
                  </p>
                </div>
                @if (
                  configuration.custom.paymentPage.capturePhone &&
                  paymentDetails.phone
                ) {
                  <div class="flex mb-4 md:mb-0">
                    <div class="flex-shrink-0 mr-2 md:mr-4">
                      <label class="label" for="Country">Country Code</label>
                      <select
                        type="text"
                        [disabled]="!!patron"
                        class="bg-white input"
                        (ngModelChange)="onChangeCountry($event)"
                        id="countryCode"
                        name="countryCode"
                        [(ngModel)]="paymentDetails.phone.countryCode">
                        @for (item of countryList; track item.icaoCode) {
                          <option [value]="item.icaoCode">
                            +{{ item.phoneCode }} ({{ item.icaoCode }})
                          </option>
                        }
                      </select>
                    </div>
                    <div class="w-full" class="flex-1">
                      <label class="label" for="city">Phone</label>
                      <input
                        type="text"
                        class="input"
                        placeholder="XXXXXXXX"
                        id="phone"
                        name="phone"
                        [(ngModel)]="paymentDetails.phone.phone"
                        [readOnly]="patron" />
                    </div>
                  </div>
                }
              </div>

              <div
                id="dropin-container"
                [class.hidden]="paymentDetails.digitalWallet !== null"></div>
              <button
                id="braintree-button"
                class="bg-main-light disabled:opacity-30 ml-auto disabled:hover:transform-none hover:scale-95 transition-transform btn-main"
                [class.hidden]="paymentDetails.digitalWallet !== null">
                Use this card
              </button>
              <div></div>
            </div>
          </div>
        </form>
      </div>

      <div class="flex justify-center md:justify-end mt-7">
        <button
          data-cy="pay-button"
          class="disabled:bg-gray-600 disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-black"
          (click)="checkout()">
          Checkout
          <span class="ml-4"
            ><img src="/assets/img/arrow-right-white-icon.svg" alt=""
          /></span>
        </button>
      </div>
    </div>
  </div>
}
